import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';

export default function Empty() {
    const { t } = useTranslation();
    return (
        <div className="flex flex-col justify-center items-center h-[80vh]">
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
            >
                <g clip-path="url(#clip0_1150_16407)">
                    <path
                        d="M20.66 7.00009C23.422 11.7831 21.783 17.9001 17 20.6601C12.877 23.0401 7.76705 22.1511 4.66505 18.8001C4.48939 18.6047 4.39769 18.348 4.40978 18.0855C4.42187 17.8231 4.53677 17.5759 4.72965 17.3975C4.92253 17.219 5.17788 17.1237 5.4405 17.1321C5.70311 17.1404 5.95189 17.2518 6.13305 17.4421C7.36858 18.7745 9.02091 19.6466 10.8181 19.9149C12.6153 20.1832 14.4503 19.8316 16.0211 18.9181C17.5919 18.0045 18.8049 16.5835 19.4604 14.8887C20.116 13.194 20.1751 11.3265 19.6279 9.59375C19.0808 7.86096 17.96 6.36606 16.4501 5.35508C14.9402 4.3441 13.1311 3.87726 11.3205 4.03142C9.50996 4.18557 7.80582 4.95151 6.48855 6.2032C5.17128 7.45489 4.31938 9.11774 4.07305 10.9181L5.35405 10.5831C6.40105 10.3101 7.17205 11.5531 6.46205 12.3701L4.21005 14.9571C3.64205 15.6091 2.54505 15.3871 2.31805 14.5131C1.76903 12.395 1.92966 10.1553 2.77532 8.13722C3.62099 6.11915 5.10504 4.43403 7.00005 3.34009C11.783 0.579087 17.899 2.21709 20.66 7.00009ZM12 6.00009C12.2653 6.00009 12.5196 6.10544 12.7072 6.29298C12.8947 6.48052 13 6.73487 13 7.00009V11.5861L15.707 14.2931C15.8026 14.3853 15.8787 14.4957 15.9311 14.6177C15.9836 14.7397 16.0111 14.8709 16.0123 15.0037C16.0134 15.1365 15.9881 15.2681 15.9379 15.391C15.8876 15.5139 15.8133 15.6256 15.7194 15.7195C15.6255 15.8134 15.5139 15.8876 15.391 15.9379C15.2681 15.9882 15.1364 16.0135 15.0036 16.0123C14.8709 16.0112 14.7396 15.9836 14.6176 15.9312C14.4956 15.8788 14.3853 15.8026 14.293 15.7071L11.293 12.7071C11.1055 12.5196 11.0001 12.2653 11 12.0001V7.00009C11 6.73487 11.1054 6.48052 11.2929 6.29298C11.4805 6.10544 11.7348 6.00009 12 6.00009Z"
                        fill="#4C4C4C"
                    />
                </g>
                <defs>
                    <clipPath id="clip0_1150_16407">
                        <rect width="24" height="24" fill="white" />
                    </clipPath>
                </defs>
            </svg>
            <p className="text-[#4C4C4C] text-base mb-4 mt-3">
                {t('History is empty')}
            </p>
            <Link
                to={'/future'}
                className="px-8 py-3 rounded-full bg-white text-black mb-10 font-medium"
            >
                {t('Trade Now')}
            </Link>
        </div>
    );
}
